module.exports = __webpack_public_path__ + "img/txfw.15e3700.png";